<template>
  <div :class="{collapsed: navCollapsed}">
    <div class="categories">
      <category-navigation-item
        v-for="category in sortedCategories"
        :key="category.id"
        :category="category"
      ></category-navigation-item>
    </div>
    <div v-if="category && this.$route.params['category']"
         class="breadcrumb flex items-center position-relative"
         :class="category.slug"
    >
      <div class="col-8 col-lg-9 breadcrumb-1 text-white pl-12 mb-0">
        <router-link :to="{name: 'student'}">Home</router-link> /
        <router-link :to="{name: 'category'}" :class="{uppercase: this.$route.name === 'category'}">{{ this.category.name }}</router-link>
        <template v-if="article && this.$route.name === 'article'">
          <span> / </span>
          <router-link :to="{name: 'article'}" class="uppercase">{{ article.first_name }} {{ article.last_name }}</router-link>
        </template>
      </div>
      <div class="col-4 col-lg-3 flex justify-between tools" v-if="article && this.$route.name === 'article'">
        <div class="ml-7 flex justify-center">
        </div>
        <button class="collapse-toggle" @click="collapse()"><img alt="collapse" src="../../assets/images/double-arrow.svg"/></button>
      </div>
    </div>
    <div v-if="this.$route.name === 'searchResults'" class="breadcrumb flex items-center position-relative bg-secondary">
      <div class="col-8 col-lg-9 breadcrumb-1 text-white pl-12 mb-0">
        <router-link :to="{name: 'student'}">Home</router-link> /
        <router-link :to="{name: 'searchResults', query: this.$route.query}" class="uppercase">Search Results</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import CategoryNavigationItem from './CategoryNavigationItem';
  import { isNull } from "@/common/utils/utils";
  import { TOGGLE_CATEGORY_NAV } from '@/store/actions/article.actions';

  export default {
    name: 'CategoryNavigation',

    components: {
      CategoryNavigationItem,
    },

    props: ['categories'],

    data: function () {
      return {
        selectedTool: {},
      }
    },

    mounted: function () {
      // add horizontal scrolling on the category navbar
      const categories = document.querySelector('.categories');
      let mouseIsDown = false;
      let startX, scrollLeft;

      categories.addEventListener('mousedown', function(e) {
        mouseIsDown = true;
        startX = e.pageX - categories.offsetLeft;
        scrollLeft = categories.scrollLeft;
      });
      categories.addEventListener('mouseleave', function() {
        mouseIsDown = false;
      });
      categories.addEventListener('mouseup', function() {
        mouseIsDown = false;
      });
      categories.addEventListener('mousemove', function(e) {
        if(!mouseIsDown) return;
        e.preventDefault();
        const x = e.pageX - categories.offsetLeft;
        const walk = (x - startX) * 3; //scroll-fast
        categories.scrollLeft = scrollLeft - walk;
      })
    },

    computed: {
      articleSections: function () {
        const parser = new DOMParser();
        const doc = parser.parseFromString(this.article.content.trim(), 'text/html');
        const headers = doc.getElementsByClassName('section-header');

        let sections = [];
        if (this.article.fast_facts) {
          sections.push({
            name: 'Fast Facts',
            class: 'fast-facts'
          })
        }
        for (let header of headers) {
          sections.push({
            name: header.innerHTML,
            class: header.innerHTML.replace(new RegExp(/\s+/, 'g'), '-').toLowerCase()
          });
        }

        return sections;
      },

      lgFirstName: function() {
        return this.article.first_name && this.article.first_name.length > 16;
      },

      lgLastName: function() {
        return this.article.last_name && this.article.last_name.length > 16;
      },

      hasLgName: function() {
        return this.lgFirstName || this.lgLastName;
      },

      navTitleClass: function() {
        return this.hasLgName ? 'col-md-3 body-8 article-nav-title' : 'offset-lg-1 col-lg-2 col-md-3 body-8 article-nav-title'
      },

      tools: function() {

        return [
          {id: 1, name: 'Glossary', class: 'glossary', selected: false, visible: true},
          {id: 2, name: 'Source Notes', class: 'source-notes', selected: false, visible: !isNull(this.article.source_notes)},
          {id: 3, name: 'Cite This', class: 'cite-this', selected: false, visible: true}
        ];
      },

      sortedCategories: function() {
        return [...this.categories].sort((a, b) => parseInt(a.order) - parseInt(b.order));
      },

      ...mapGetters({category: 'category', article: 'selectedArticle', navCollapsed: 'navCollapsed'})
    },

    methods: {
      setOverlay: function (selectedTool) {
        this.selectedTool = selectedTool;
        for (let tool in this.tools) {
          this.tools[tool].selected = this.tools[tool].name === selectedTool.name;
        }
      },
      unsetTabs: function () {
        // unset all tabs because overlay was closed
        this.selectedTool = {};
        for (let tool in this.tools) {
          this.tools[tool].selected = false;
        }
      },
      scrollToTag: function (tagName) {
        const el = document.getElementById(tagName);
        const offset = this.navCollapsed ? 107 : 328;
        if (el) {
          window.scrollTo({
            top: el.offsetTop - offset,
            behavior: 'smooth'
          });
        }
      },
      collapse() {
        this.$store.dispatch(TOGGLE_CATEGORY_NAV, !this.navCollapsed);
      }
    }
  }

</script>

<style lang="scss" scoped>
  .collapsed {
    .categories {
      opacity: 0;
    }

    .collapse-toggle {
      img {
        transform: rotate(90deg);
      }
    }
  }

  .categories {
    @apply flex relative pt-3 pb-2 px-3;
    opacity: 1;
    transition: opacity .15s ease;
    /* Hide scrollbar while maintaining scrollability */
    overflow: auto hidden;
    cursor: grab;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .breadcrumb {
    height: 40px;

    a {
      @apply text-white;

      &:hover {
        @apply text-grey-5;
      }
    }

    &.craft {
      @apply bg-c1-e;
    }

    &.build {
      @apply bg-c2-e;
    }

    &.experiment {
      @apply bg-c3-e;
    }

    &.eat {
      @apply bg-c4-e;
    }

    &.celebrate {
      @apply bg-c5-e;
    }
  }

  .article-nav {
    height: 72px;

    .article-nav-title {
      color: #ffffff;
    }

    &.craft {
      @apply bg-c1-f1;

      .profile-nav-item {
        @apply bg-c1-f2;
        &:hover {
          @apply bg-c1-f4;
        }
      }
    }

    &.build {
      @apply bg-c2-f1;

      .profile-nav-item {
        @apply bg-c2-f2;
        &:hover {
          @apply bg-c2-f4;
        }
      }
    }

    &.experiment {
      @apply bg-c3-f1;

      .profile-nav-item {
        @apply bg-c3-f2;
        &:hover {
          @apply bg-c3-f4;
        }
      }
    }

    &.eat {
      @apply bg-c4-f1;

      .profile-nav-item {
        @apply bg-c4-f2;
        &:hover {
          @apply bg-c4-f4;
        }
      }
    }

    &.celebrate {
      @apply bg-c5-f1;

      .profile-nav-item {
        @apply bg-c5-f2;
        &:hover {
          @apply bg-c5-f4;
        }
      }
    }

    &.default {
      @apply bg-grey-1;

      .profile-nav-item {
        @apply bg-grey-2;
        &:hover {
          @apply bg-grey-4;
        }
      }
    }
  }

  .profile-carousel-wrapper {
    padding-right: 13px;
  }

  .prof-nav {
    width: 20px;
    height: 100%;
    display: flex;
    align-items: center;
    overflow-x: hidden;

    &:hover {
      .arrow {
        @apply border-grey-4;
      }

      cursor: pointer;
    }

    .arrow {
      border: 1px solid white;
      @apply border-2 border-solid border-white border-t-0 border-l-0;
      width: 20px;
      height: 20px;


      &.arrow-prev {
        transform: rotate(135deg);
        margin-left: 5px;
      }

      &.arrow-next {
        transform: rotate(315deg);
        margin-left: -5px;
      }
    }
  }

  .profile-nav-item {
    width: 186px;
    height: 64px;
    padding: 5px 10px;
    @apply text-white;

    &:hover {
      cursor: pointer;
    }
  }

  .collapse-toggle {
    outline: none;

    img {
      height: 25px;
      transform: rotate(270deg);
      transition: all .25s ease;
    }
  }
</style>
